const userLabel = require("../label/user");

const note_story_like = {
  key: "note_story_like",
  count_alias: "count_story_likes_new",
  label_activity: "story likes",
  label_data: "new story like",
  label_detail: "A user likes a story I've published.",
  label_title: () => "New Story Like",
  label_zero_state:
    "When a user likes a story you've published, we'll notify you here.",
  makeNote: (user) => userLabel(user) + " liked your story.",
  makeLink: ({ slug }) => `/story/${slug}/likes`,
  table: "story_like",
  leftJoins: ["story", "user"],
  keys: [
    "story_like.id AS id",
    "story_like.created_at AS noted_at",
    "story.slug AS slug",
    "user.username AS username",
    "user.display_name AS display_name",
  ],
  wheres: ["story.author_id = ?", "story_like.user_id <> ?"],
  where_since: {
    index: 1,
    sql: "story_like.created_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.id, user.id],
};

module.exports = note_story_like;
